var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModulsoffa01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 320.89 285.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4.21 271.89 332.7 271.89 332.7 9.54 4.21 9.54 4.21 271.89"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "50.44 119.19 50.44 53.07 248.85 53.07 267.75 71.97 267.75 232.59 201.6 232.59 201.6 251.46 286.65 251.46 286.65 63.12 258.57 34.17 31.54 34.17 31.54 119.19 50.44 119.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "192.16 53.07 192.16 119.19 201.6 128.64 267.75 128.64 267.75 71.97 248.85 53.07 192.16 53.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "50.44 53.07 97.69 53.07 97.69 119.19 50.44 119.19 50.44 53.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "97.69 53.07 144.94 53.07 144.94 119.19 97.69 119.19 97.69 53.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "144.94 53.07 192.16 53.07 192.16 119.19 144.94 119.19 144.94 53.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "201.6 128.64 267.75 128.64 267.75 180.6 201.6 180.6 201.6 128.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "201.6 180.6 267.75 180.6 267.75 232.59 201.6 232.59 201.6 180.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModulsoffa01);
export default __webpack_public_path__ + "static/media/modulsoffa-01.cce8d9e765d9b6ae01e720fa9a6a93fd.svg";
export { ForwardRef as ReactComponent };